import { Skeleton, styled } from '@mui/material'

export const StyledSimilarProjectLogoSkeleton = styled(Skeleton)(({ theme }) => ({
  marginBottom: theme.spacing(3),
  backgroundColor: theme.palette.surface['700'],
  width: '405px',
  height: '405px',
  [theme.breakpoints.down('lg')]: {
    width: '342px',
    height: '342px',
  },
  [theme.breakpoints.down('sm')]: {
    width: '240px',
    height: '240px',
  },
}))

export const StyledSimilarProjectTitleSkeleton = styled(Skeleton)(({ theme }) => ({
  marginBottom: theme.spacing(1),
  backgroundColor: theme.palette.surface['700'],
  width: '405px',
  height: '26px',
  [theme.breakpoints.down('lg')]: {
    width: '342px',
  },
  [theme.breakpoints.down('sm')]: {
    width: '240px',
  },
}))

export const StyledSimilarProjectSubtitleSkeleton = styled(Skeleton)(({ theme }) => ({
  backgroundColor: theme.palette.surface['700'],
  width: '405px',
  height: '42px',
  [theme.breakpoints.down('lg')]: {
    width: '342px',
  },
  [theme.breakpoints.down('sm')]: {
    width: '240px',
  },
}))
